import React from 'react';
import {useRecoilValue, useSetRecoilState} from 'recoil';
import {useNavigate} from 'react-router-dom';

import {isOpenTempAlert, isOpenToast, ToastMessage} from '../../../store';

interface Props {
  tempItem: TempItem | undefined;
  type: 'save' | 'delete';
  save?: () => void;
  remove?: () => void;
}

interface AlertInfo {
  title: string;
  subTitle: string;
  btnTxt: string;
  cancelTxt: string;
  toggle: () => void;
}

export default function TempAlert({type, tempItem, save, remove}: Props) {
  const navigator = useNavigate();
  const openModal = useRecoilValue(isOpenTempAlert);
  const setOpenModal = useSetRecoilState(isOpenTempAlert);
  const setToastMessage = useSetRecoilState(ToastMessage);
  const setIsOpenToast = useSetRecoilState(isOpenToast);
  const items = {
    save: {
      title: tempItem
        ? '현재 글을 임시 저장하시겠어요?'
        : '작성하신 내용을 저장하시겠어요?',
      subTitle: tempItem
        ? '기존 임시저장 게시글은 삭제됩니다.'
        : '지금 페이지를 벗어나면 내용이 모두 사라집니다.',
      btnTxt: tempItem ? '현재 글 임시 저장' : '임시 저장',
      cancelTxt: tempItem ? '취소' : '삭제하고 나가기',
      toggle: save,
    } as AlertInfo,
    delete: {
      title: '임시저장 게시글을 삭제하시겠습니까?',
      subTitle: '삭제시 복구할 수 없습니다.',
      btnTxt: '삭제',
      cancelTxt: '취소',
      toggle: remove,
    } as AlertInfo,
  };
  const toggle = async () => {
    items[type].toggle();
    if (type === 'save') {
      await setToastMessage('저장되었습니다.');
      setIsOpenToast(true);
      navigator('/community');
    }
  };
  const cancel = () => {
    setOpenModal(false);
    if (type === 'save') {
      navigator('/community');
    }
  };
  return (
    <div
      className="modal-wrapper alert"
      style={{
        display: openModal ? 'flex' : 'none',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <div
        className="modal-contents community-alert"
        style={{
          width: '335px',
          background: '#fff',
          borderRadius: '10px',
          padding: '20px',
        }}>
        <div
          className="close-btns"
          style={{display: 'flex', justifyContent: 'flex-start'}}>
          <span
            className="icon close-gray-icon"
            style={{
              width: '14px',
              height: '14px',
              display: 'inline-block',
              cursor: 'pointer',
            }}
            onClick={() => setOpenModal(false)}>
            &nbsp;
          </span>
        </div>
        <div
          className="login-modal-header"
          style={{
            marginTop: '25px',
            fontWeight: 700,
            fontSize: '18px',
            lineHeight: '25.2px',
            letterSpacing: '-2%',
            textAlign: 'center',
          }}>
          {items[type].title}
        </div>
        <div
          className="login-modal-info"
          style={{
            marginTop: '10px',
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '140%',
            letterSpacing: '-0.02em',
            textAlign: 'center',
          }}>
          {items[type].subTitle}
        </div>
        <div className="login-btn-wrapper" style={{marginTop: '40px'}}>
          <button
            className="modal btn"
            style={{
              fontWeight: 600,
              fontSize: '14px',
              background: '#000',
              color: '#fff',
            }}
            onClick={() => toggle()}>
            {items[type].btnTxt}
          </button>
          <button
            className="modal btn cancel"
            style={{fontWeight: 600, color: '#D2D0D5', fontSize: '14px'}}
            onClick={() => cancel()}>
            {items[type].cancelTxt}
          </button>
        </div>
      </div>
    </div>
  );
}
